import { render, staticRenderFns } from "./ImageGalleryAction.vue?vue&type=template&id=1818a99c&scoped=true&"
import script from "./ImageGalleryAction.vue?vue&type=script&lang=js&"
export * from "./ImageGalleryAction.vue?vue&type=script&lang=js&"
import style0 from "./ImageGalleryAction.vue?vue&type=style&index=0&id=1818a99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818a99c",
  null
  
)

export default component.exports